import { Slider as MantineSlider } from "@mantine/core";
import classnames from "classnames";
import { componentWrapper } from "../../utilities";
import styles from "./slider.module.scss";
import type { CustomSliderFactory, IProps } from "./slider.types";

/**
 * Slider component.
 * @param {object} props.classNames - Custom class names combined with the default slot classes.
 * @returns {JSX.Element} The Slider component.
 */
const Slider = componentWrapper<CustomSliderFactory, IProps>("Slider", ({ classNames, ...otherProps }, ref) => {
    return (
        <MantineSlider
            ref={ref}
            classNames={{
                root: classnames(styles["root"], typeof classNames === "object" ? classNames?.root : ""),
                label: classnames(styles["label"], typeof classNames === "object" ? classNames?.label : ""),
                thumb: classnames(styles["thumb"], typeof classNames === "object" ? classNames?.thumb : ""),
                trackContainer: classnames(
                    styles["track-container"],
                    typeof classNames === "object" ? classNames?.trackContainer : ""
                ),
                track: classnames(styles["track"], typeof classNames === "object" ? classNames?.track : ""),
                bar: classnames(styles["bar"], typeof classNames === "object" ? classNames?.bar : ""),
                markWrapper: classnames(
                    styles["mark-wrapper"],
                    typeof classNames === "object" ? classNames?.markWrapper : ""
                ),
                mark: classnames(styles["mark"], typeof classNames === "object" ? classNames?.mark : ""),
                markLabel: classnames(
                    styles["mark-label"],
                    typeof classNames === "object" ? classNames?.markLabel : ""
                ),
            }}
            {...otherProps}
        />
    );
});

export { Slider };
